import React, { useEffect, useState } from 'react';
import GridCellWrapper from '../../../../components/grid-cell-wrapper/GridCellWrapper';
import { StateModel, StateModel_Admin } from '../../../../redux/store';
import { connect } from 'react-redux';
import { getDefaultstatuskette } from '../../../../redux/actions/auftrag';
import { Sendungsstatus } from '../../../../api';
import Modal from '../../../../components/modal/Modal';
import IconPicker from '../../../dev/icon-picker/IconPicker';
import {
  setDefaultstatuskette,
  updateSendungsStatus,
} from '../../../../redux/actions/admin';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import Button from '../../../../components/button/Button';

interface DefaultStatusketteProps {
  defaultstatuskette: Sendungsstatus[];
  getDefaultstatuskette: () => void;
  updateSendungsStatus: (
    value: Sendungsstatus,
    anzeigestatus: boolean,
    edit: boolean
  ) => void;
  setDefaultstatuskette: (sendungsstatusKatte: Sendungsstatus[]) => void;
  admin: StateModel_Admin;
}

const DefaultStatuskette = (props: DefaultStatusketteProps) => {
  const [show, setShowModal] = useState(false);
  const [pickedIcon, setPickedIcon] = useState('');
  const [activeStatus, setActiveStatus] = useState<Sendungsstatus>({ id: -1 });
  const [anzeigestati, setAnzeigeStati] = useState<Array<any>>(
    props.defaultstatuskette
  );

  useEffect(() => {
    props.getDefaultstatuskette();
  }, []);

  const chooseIcon = (status: Sendungsstatus) => {
    setActiveStatus(status);
    setShowModal(true);
  };

  const handleClose = () => {
    const status: Sendungsstatus = {
      id: activeStatus.id,
      anzeige: activeStatus.anzeige,
      awSperre: activeStatus.awSperre,
      kurzBezeichnung: activeStatus.kurzBezeichnung,
      sdst_id_anzeige: activeStatus.sdst_id_anzeige,
      anzeigefolge: activeStatus.anzeigefolge,
      icon: pickedIcon,
      defaultstatus: activeStatus.defaultstatus,
    };
    props.updateSendungsStatus(status, true, true);

    setShowModal(false);
  };

  const handleDrop = (result: any) => {
    if (
      //Die ersten beiden sollen immer unverändert bleiben!
      !result.destination ||
      result.destination.index < 2 ||
      result.source.index < 2
    )
      return;
    const updatedList = [...props.defaultstatuskette];
    /* const [reorderedItem] = updatedList.splice(result.source.index, 1);
    updatedList.splice(result.destination.index, 0, reorderedItem);*/

    updatedList[result.source.index].anzeigefolge =
      result.destination.index + 1;
    updatedList[result.destination.index].anzeigefolge =
      result.source.index + 1;
    setAnzeigeStati(updatedList);
    props.setDefaultstatuskette(updatedList);
    props.admin.reloadSendungsStati;
  };

  const anzeigefolgeComparator = (a: Sendungsstatus, b: Sendungsstatus) => {
    if (a.anzeigefolge && b.anzeigefolge) {
      if (a.anzeigefolge < b.anzeigefolge) {
        return -1;
      }
      if (a.anzeigefolge > b.anzeigefolge) {
        return 1;
      }
      return 0;
    }
    return 0;
  };

  return (
    <GridCellWrapper classes='statuskette' label='Defaultstatuskette'>
      <div className='statuskette-info'>
        <DragDropContext onDragEnd={handleDrop}>
          <Droppable droppableId='list-container'>
            {provided => (
              <div
                className='list-container'
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {props.defaultstatuskette
                  ?.sort(anzeigefolgeComparator)
                  .map((item, index) => {
                    if (
                      item.anzeigefolge == undefined ||
                      item.anzeigefolge > 2
                    ) {
                      return (
                        <Draggable
                          key={item.id}
                          draggableId={`${item.id}`}
                          index={index}
                        >
                          {provided => (
                            <div
                              className='item-container'
                              ref={provided.innerRef}
                              {...provided.dragHandleProps}
                              {...provided.draggableProps}
                            >
                              {
                                <div id='Status' key={item.id}>
                                  <Button
                                    classes={'iconbutton'}
                                    onClickHandler={() => chooseIcon(item)}
                                  >
                                    <i className={item.icon}></i>
                                  </Button>
                                  <label
                                    id={'bez'}
                                    title={
                                      'zum Sortieren an die gewünschte Position verschieben'
                                    }
                                  >
                                    {item.kurzBezeichnung}
                                  </label>
                                </div>
                              }
                            </div>
                          )}
                        </Draggable>
                      );
                    } else {
                      return (
                        <div id='Status' key={item.id}>
                          <Button
                            classes={'iconbutton'}
                            onClickHandler={() => chooseIcon(item)}
                          >
                            <i className={item.icon}></i>
                          </Button>
                          <label id={'bez_non_sort'}>
                            {item.kurzBezeichnung}
                          </label>
                        </div>
                      );
                    }
                  })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        {/*
        Code VOR D&D, soll als Bsp. hier stehen bleiben!!!
*/}
        {/*        {props.defaultstatuskette?.map(dss => (
          <div id='Status' key={dss.id}>
            <Button
              classes={'iconbutton'}
              onClickHandler={() => chooseIcon(dss)}
            >
              <i className={dss.icon}></i>
            </Button>
            <label id={'bez'}>{dss.kurzBezeichnung}</label>
          </div>
        ))}*/}
      </div>

      <Modal
        show={show}
        closeHandler={() => setShowModal(false)}
        titel='Icon auswählen'
      >
        <IconPicker setPickedIcon={setPickedIcon} />
        <div className='modal-btn-group'>
          <button className='modal-btn' key={6} onClick={() => handleClose()}>
            OK
          </button>
        </div>
      </Modal>
    </GridCellWrapper>
  );
};

const mapStateToProps = (state: StateModel) => ({
  defaultstatuskette: state.Stammdaten.defaultstatuskette,
  admin: state.Admin,
});

export default connect(mapStateToProps, {
  getDefaultstatuskette,
  setDefaultstatuskette,
  updateSendungsStatus,
})(DefaultStatuskette);
